export enum AccordionMode {
  DEFAULT = 'default',
  COLLAPSIBLE = 'collapsible',
  MULTIPLE = 'multiple'
}
